import React from "react";
import { getAccessToken, getRoles } from "../utils/session";
import { NavLink } from "react-router-dom";
import { Box, Typography } from "@mui/material";

const navItems = {
  admin: [
    { to: "/programs", label: "Programs" },
    { to: "/organizations", label: "Organizations" },
    { to: "/promotions", label: "Promotions" },
    { to: "/closure", label: "Closure Matrix" },
    { to: "/queued-requests", label: "Queued Requests" },
    { to: "/reports", label: "Reports" },
    { to: "/real-time-test", label: "Real Time Test" },
    { to: "/download-codes", label: "Download Codes" },
    { to: "/public-key", label: "Public Key" },
    { to: "/validate", label: "Validate" },
  ],
  mktusers: [
    { to: "/programs", label: "Programs" },
    { to: "/organizations", label: "Organizations" },
    { to: "/promotions", label: "Promotions" },
    { to: "/closure", label: "Closure Matrix" },
    { to: "/queued-requests", label: "Queued Requests" },
    { to: "/reports", label: "Reports" },
  ],
  recipients: [
    { to: "/download-codes", label: "Download Codes" },
    { to: "/public-key", label: "Public Key" },
  ],
  support: [
    { to: "/validate", label: "Validate" },
  ],
};

const Navigation = ({ user }) => {
  const roles = getRoles(user);
  getAccessToken(user);
  let items = [];
  if (roles.includes("SEC-IDM-CODES-MG_GBCOSTAMKT1-ADMINUSER")) items = navItems.admin;
  else if (roles.includes("SEC-IDM-CODES-MG_USMKT1-MKTUSERS")) items = navItems.mktusers;
  else if (roles.includes("SEC-IDM-CODES-RECIPIENTS")) items = navItems.recipients;
  else if (roles.includes("SEC-IDM-CODES-SUPPORT")) items = navItems.support;

  return (
    <Box
      component="nav"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        backgroundColor: 'red', // You may need to use theme.palette or a hex value
        height: '2.5rem', // h-10
        alignItems: 'center',
      }}
    >
      <Box
        component="ul"
        id="navigation"
        sx={{
          display: { xs: 'none', md: 'flex' },
          gap: '1.5rem', // gap-x-6
          paddingLeft: '5rem', // pl-20
          color: '#f1f5f9', // text-slate-50
          height: '2.5rem', // h-10
          alignItems: 'center',
          listStyle: 'none',
          margin: 0,
        }}
      >
        {items.map(({ to, label }) => (
          <li key={to}>
            <NavLink to={to} style={{ textDecoration: 'none' }} className={({ isActive }) => ''}>
              {({ isActive }) => (
                <Typography
                  sx={{
                    color: isActive ? 'primary.main' : '#f1f5f9',
                    fontWeight: isActive ? 700 : 400,
                    transition: 'color 0.2s',
                  }}
                >
                  {label}
                </Typography>
              )}
            </NavLink>
          </li>
        ))}
      </Box>
    </Box>
  );
};

export default Navigation;
